import React, { Component, useState } from "react";
import { assessmentActions, questionsActions, userActions } from "../../../_actions";
import { connect } from "react-redux";
import moment from "moment";
import DashboardUser from "../../AdminPanel/Dashboard/DashboardUser";
import Heading from "../../AdminPanel/Component/UI/ViewButton";
import { MdOutlineStarOutline } from "react-icons/md";
import RadarEnergyChart from "./Components/RadarEnergyChart";

let getFlowCategory = (score) => {
  let obj = {
    LABEL: "",
    TEXTCOLOR: "",
    CLASSCOLOR: "",
    TEXT: "",
  }
  if (score >= 19 && score <= 25) {
    obj["LABEL"] = 'PRIMARY';
    obj["TEXTCOLOR"] = 'text-emerald-700';
    obj["COLORCLASS"] = 'bg-emerald-50 text-emerald-700 border-emerald-200'
    obj["TEXT"] = 'Your dominant, most natural path into flow. Build your work, environment, and rituals around it.'
  } else if (score >= 13 && score <= 18) {
    obj["LABEL"] = 'SECONDARY';
    obj["TEXTCOLOR"] = 'text-sky-700';
    obj["COLORCLASS"] = 'bg-sky-50 text-sky-700 border-sky-200'
    obj["TEXT"] = 'Your strong support profile. Lean on it when your primary route is blocked or unavailable.'
  } else if (score >= 7 && score <= 12) {
    obj["LABEL"] = 'TERTIARY';
    obj["TEXTCOLOR"] = 'text-amber-700';
    obj["COLORCLASS"] = 'bg-amber-50 text-amber-700 border-amber-200'
    obj["TEXT"] = 'A situational mode you can access but do not default to.'
  } else if (score >= 0 && score <= 6) {
    obj["LABEL"] = 'LEAST USED';
    obj["TEXTCOLOR"] = 'text-red-500';
    obj["COLORCLASS"] = 'bg-red-50 text-red-500 border-red-200'
    obj["TEXT"] = 'Untapped range - not a weakness. Deliberate practice here widens where you can find flow.'
  } else {
    obj["LABEL"] = 'N/A';
    obj["TEXTCOLOR"] = 'text-gray-400'
    obj["COLORCLASS"] = 'bg-gray-50 text-gray-700 border-gray-200'
    obj["TEXT"] = ''
  }
  return obj
}

const FLOW_PROFILE_DATA = [
  {
    id: 1,
    title: 'Deep Thinker',
    barColor: '#0369a1', // Dark solid blue
  },
  {
    id: 2,
    title: 'Hard Charger',
    barColor: '#b91c1c', // Rust red
  },
  {
    id: 3,
    title: 'Flow Goer',
    barColor: '#0f766e', // Teal blue-green
  },
  {
    id: 4,
    title: 'Crowd Pleaser',
    barColor: '#8b5cf6', // Vivid violet-purple
  }
];

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      top5Talent: false,
      isDisableSubmit: false,
      SurveyCode: this.props.codeValue,
      routeMenu: "Summary",
      radioButton: false,
      radioButton2: false,
      currQues: null,
      showWelcomeScreen: true,
      showQuestionScreen: false,
      showThankyouScreen: false,
      instructionPage: false,
      showRedFlag: false,
      saveMsg: "",
      CurrQuesIndex: 1,
      submitSucces: false,

      surveyLanguageName: "English",
      ShowSubmitButton: false,

      textAnswer: "",
      unattemptList: [],
      changeType: "fade",
      mandatoryOn: false,
      afterSubmitData: {
        thankyouText: "",
        bgColor: "",
        bgImage: "",
        textcolor: "",
        logo: "",
      },
      alreadySubmitted: false,
      clicked: false,

      showDropdownQues: false,
      dropdownInput: "",
      scrollPosition: 0,
      IpObj: {},
      ShowNotAttempted: false,
      submitMandatory: "",
      setTimeoutRef: "",
      setTimeoutInit: 0,
      disableTimer: false,
      timeCounter: 0,
      setIntervalRef: "",
      showReportModal: false,
      showSummaryReport: false,
      showManagerReportModal: false,
      showHiringReport: false,

      showViewReportThankYouButton: false,
      surveyLanguageCode: "",
      activeTab: "all",
      themeType: 2,
      showNameEditScreen: false,
      nameFormData: {
        name: '',
        email: '',
        gender: '',
        ageGroup: ''
      },
      errNameForm: {
        name: '',
        email: '',
        gender: '',
        ageGroup: ''
      },
      backSummary: false,
      showMainSummaryModal: false,
      crrDetail: "",
      crrCodeUserDetails: {
        "employeeId": "",
        "name": "",
        "email": "",
        "mobile": "",
        "message": ""
      },
      errorsCrrCodeUserDetails: {},
      topFiveTalent: true,
      contactExpertSection: false,
      showMyExpertList: false,
      showVideoModal: '',
      showVideoResource: false,
      showMainMenu: "Summary",
      downloadStatusNo: 100,
      surveyLanguageCode: 'en',
      surveyLanguageName: 'English',
      surveyLanguageRTL: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(questionsActions.emptyReducer());
    this.props.dispatch(questionsActions.getCoachUserSurveyList({}));
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());

  }

  decrementNumber = () => {
    this.setState((prevState) => ({
      downloadStatusNo: prevState.downloadStatusNo < 1 ? 0 : prevState.downloadStatusNo - 10,
    }));
  };

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.questions.submitfail) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: false,

        alreadySubmitted: true,
      };
    }
    if (nextProps.questions.answerSubmitSuccess) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: true,
        instructionPage: false,
      };
    } else {
      return {
        ...nextProps,
      };
    }
  }

  getBadgeStyle = (status) => {
    switch (status) {
      case 'Completed':
        return 'bg-emerald-50 text-emerald-500 border-emerald-100';
      case 'In-Progress':
        return 'bg-amber-50 text-amber-500 border-amber-100';
      case 'Not started':
      default:
        return 'bg-blue-50 textcolor border-purple-100';
    }
  };

  takeAssessment = (code) => {
    this.props.history.push(`/assessment/questions/` + code);
  }

  viewReport = (isRiskSurveyType, code) => {
    if (isRiskSurveyType === "DEFAULTFOCUS") {
      this.props.history.push(`/assessment/focusprofilereport/` + code);
    } else if (isRiskSurveyType === "DEFAULTENERGY") {
      this.props.history.push(`/assessment/energyprofilereport/` + code);
    }
  }

  render() {
    const { routeMenu } = this.state;
    let { questions, assessment, onLogout, switchToAdmin, openAIBot,
    } = this.props;

    let { getAssessmenrEmployeeDetailsData, getCoachUserSurveyListData } = questions;
    let { userAssessmentUserProfileData } = assessment;

    // console.log('getAssessmenrEmployeeDetailsDatagetAssessmenrEmployeeDetailsData', getAssessmenrEmployeeDetailsData);


    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod()
    };

    let cardList =
      getCoachUserSurveyListData && getCoachUserSurveyListData.length > 0
        ? getCoachUserSurveyListData.map((ele) => ({
          id: ele.id,
          code: ele.code,
          iconType: <MdOutlineStarOutline size={32} />,
          title: ele?.productId?.name ?? "",
          responses: ele.responses,
          status: ele.isClicked
            ? (ele.isComplete ? "Completed" : "Pending")
            : "Not Started",
          date: "05 January, 2026",
          description: ele?.productId?.desc ?? "",
          isRiskSurveyType: ele?.surveyId?.isRiskSurveyType ?? "",
          btnText: ele.isComplete ? "View Report" : "Start Assessment",
        }))
        : [];

    const actionData = {
      "title": "Your Actions",
      "actionText": "See all",
      "cards": cardList
    };

    function getFlowStatic(dimension, fieldName) {
      let value = "";
      let getIndex = FLOW_PROFILE_DATA.findIndex(prev => prev.title === dimension);
      if (getIndex !== -1) {
        value = FLOW_PROFILE_DATA[getIndex][fieldName];
      }
      return value
    }

    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }

    function getAssessmentTop5List(ele) {
      let list = [];
      for (var i = 1; i <= 5; i++) {
        list.push({
          id: i,
          dimension: ele.responses["Rank" + (i.toString())],
          bucket: "THINKING TALENTS",
          color: "#FFC107",
          desc: "This is sample dimension description details. Write more"
        })
      }
      return list
    }

    function getLightColor(bucket) {
      let obj = {
        "THINKING TALENTS": "#FFF0C4",
        "ACTING TALENTS": "#CAE6FC",
        "LEADING TALENTS": "#DBD0EE",
        "RELATING TALENTS": "#D4ECD5"
      }
      return obj && obj[bucket] ? obj[bucket] : "#F2F2F2"
    }

    const tabs = [
      { key: "all", label: "All", count: 3 },
      { key: "completed", label: "Completed", count: 1 },
      { key: "pending", label: "Pending", count: 1 },
    ];

    const filteredCards =
      this.state.activeTab === "all"
        ? actionData.cards
        : actionData.cards.filter((card) =>
          this.state.activeTab === "completed"
            ? card.status === "Completed"
            : card.status !== "Completed"
        );


    return (
      <DashboardUser
        showBot={false}
        openAIBot={openAIBot}
        userDetails={userDetails}
        onLogout={onLogout}
        switchToAdmin={switchToAdmin}>

        <div className="min-h-screen overflow-hidden overflow-y-auto">

          {/* Your Action */}
          <div className="flex justify-between items-center mb-4">
            <Heading className="text-3xl cursor-none" title={actionData.title} />
            <button className="textcolor hover:text-blue-600 hove:underline text-xl flex items-center space-x-1 transition cursor-pointer">
              <span>{actionData.actionText}</span>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          <div className="mb-3">
            <div className="flex flex-wrap gap-4">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => this.setState({ activeTab: tab.key })}
                  className={`px-8 py-2 rounded-lg border text-base font-medium transition-all
                     ${this.state.activeTab === tab.key
                      ? "bg-[#1976D2] text-white border-[#1976D2]"
                      : "bg-white text-gray-900 border-gray-300 hover:border-[#1976D2]"
                    }`}>
                  {tab.label} ({tab.count})
                </button>
              ))}
            </div>
          </div>

          <div className="space-y-4 w-full mb-6">
            {filteredCards.map((card) => (
              <>
                {actionData?.cards?.map((card) => (
                  <div key={card.id} className="bg-white border border-gray-300 rounded-lg p-4 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-5 hover:shadow-sm transition-all duration-300">
                    <div className="flex items-start gap-5 w-full">
                      <div className="w-16 h-16 bg-blue-50 rounded-xl flex items-center justify-center textcolor">{card.iconType}</div>
                      <div className="flex-1">
                        <div className="flex flex-wrap items-center gap-3 mb-2">
                          <Heading className="text-xl" title={card.title} />
                          <span
                            className={`px-4 py-1 rounded-full text-sm font-semibold border ${card.status === "Completed"
                              ? "bg-green-50 text-green-600 border-green-200"
                              : card.status === "Pending"
                                ? "bg-yellow-50 text-yellow-600 border-yellow-200"
                                : "bg-blue-50 textcolor border-blue-200"
                              }`}
                          >
                            {card.status}
                          </span>
                        </div>
                        <p className="text-sm textlight leading-relaxed">{card.description}</p>
                      </div>
                    </div>

                    {/* Right Button */}
                   <button onClick={() => { card.status === "Completed" ? this.viewReport(card.isRiskSurveyType, card.code) : this.takeAssessment(card.code); }} className="border border-[#09529b] textcolor px-6 py-3 rounded-md flex items-center justify-center whitespace-nowrap space-x-2 transition duration-150 group">
                  <span>{card.btnText}</span>
                  <svg className="w-4 h-4 transform group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </button>
                  </div>
                ))}
              </>
            ))}
          </div>



          {/* 2. Map loop iterating through the rendered JSON content items */}
          {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full mb-10">
            {actionData && actionData.cards && actionData.cards.length > 0 && actionData.cards.map((card) => (
              <div key={card.id} className="bg-white border rounded-lg p-6 flex flex-col justify-between shadow-[0_4px_25px_rgba(0,0,0,0.02)] hover:shadow-md transition duration-200 text-left">
                <div>
                  <div className="w-16 h-16 bg-blue-50 rounded-xl flex items-center justify-center textcolor mb-4">{card.iconType}</div>
                  <div className="flex items-center flex-wrap gap-2 mb-2">
                    <Heading className="text-xl" title={card.title} />
                    <span className={`text-sm font-semibold px-2.5 py-0.5 rounded-full border ${this.getBadgeStyle(card.status)}`}>{card.status}</span>
                  </div>
                  <p className="text-sm textlight mb-3 leading-relaxed">{card.description}</p>
                  <p className="text-sm italic textlight mt-3 mb-6 leading-relaxed">{card.date}</p>
                </div>
                <button onClick={() => { card.status === "Completed" ? this.viewReport(card.isRiskSurveyType, card.code) : this.takeAssessment(card.code); }} className="w-full border border-[#09529b] textcolor px-4 py-3 rounded-md flex items-center justify-center space-x-2 transition duration-150 group">
                  <span>{card.btnText}</span>
                  <svg className="w-4 h-4 transform group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </button>
              </div>
            ))}
          </div> */}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full mb-10">
            {actionData && actionData.cards && actionData.cards.length > 0 && actionData.cards.map((ele) => (
              <>
                {ele && ele.isRiskSurveyType && ele.isRiskSurveyType === "DEFAULTFOCUS" && (ele && ele.responses && ele.responses.scores && ele.responses.scores.length > 0) && <>
                  <div className="bg-white border rounded-lg p-6 flex flex-col justify-between shadow-[0_4px_25px_rgba(0,0,0,0.02)] hover:shadow-md transition duration-200 text-left">
                    <div className="mb-5">
                      <Heading className="text-xl mb-2 cursor-none" title="FLOW Profile Score" />
                      <p className="text-sm textlight leading-relaxed">Identify your creative and cognitive flow state triggers for peak performance.</p>
                    </div>

                    <div className="grid grid-cols-4 gap-2 sm:gap-4 md:gap-6 items-end justify-center mb-8 px-1">
                      {ele && ele.responses && ele.responses.scores && ele.responses.scores.length > 0 && ele.responses.scores.map((profile) => (
                        <div key={profile.id} className="flex flex-col items-center group">
                          <div className="text-center mb-1">
                            <span className="text-base md:text-xl font-bold text-gray-800 font-mono">{profile.sumScore}</span>
                            <span className="text-gray-700 text-sm font-normal font-mono">/{25}</span>
                          </div>
                          <div className={`text-xs font-medium uppercase mb-4 text-center h-4 ${getFlowCategory(profile.sumScore)["TEXTCOLOR"]}`}>{
                            getFlowCategory(profile.sumScore)["LABEL"]}</div>
                          <div className="w-20 bg-gray-100 h-[15rem] rounded-xl overflow-hidden flex flex-col justify-end p-0">
                            <div className="w-20 rounded-xl transition-all duration-700 ease-out origin-bottom" style={{
                              height: ((profile.sumScore * 100) / 25).toFixed(0) + "%",
                              backgroundColor: getFlowStatic(profile.dimension, "barColor"),
                            }} />
                          </div>
                          <span className="text-sm font-medium text-gray-700 mt-4 text-center leading-tight whitespace-nowrap">{profile.dimension}</span>
                        </div>
                      ))}
                    </div>

                    <button className="w-full border border-[#09529b] textcolor px-4 py-3 rounded-md flex items-center justify-center space-x-2 transition duration-150 group">
                      <span>View Full Report</span>
                      <svg className="w-4 h-4 transform group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </button>
                  </div>
                </>}

                {ele && ele.isRiskSurveyType && ele.isRiskSurveyType === "DEFAULTENERGY" && (ele && ele.responses && ele.responses.scores && ele.responses.scores.length > 0) && <>
                  <div className="bg-white border rounded-lg p-6 flex flex-col justify-between shadow-[0_4px_25px_rgba(0,0,0,0.02)] hover:shadow-md transition duration-200 text-left">
                    <div className="mb-5">
                      <Heading className="text-xl mb-2 cursor-none" title="Energy Profile Score" />
                      <p className="text-sm textlight leading-relaxed">A snapshot of your scores across the four flow profiles.</p>
                    </div>
                    <div className="space-y-4 mb-8">
                      <RadarEnergyChart dimensionScores={ele && ele.responses && ele.responses.scores && ele.responses.scores.length > 0 ? ele.responses.scores : []} />
                    </div>

                    <button className="w-full border border-[#09529b] textcolor px-4 py-3 rounded-md flex items-center justify-center space-x-2 transition duration-150 group">
                      <span>View Full Report</span>
                      <svg className="w-4 h-4 transform group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </button>
                  </div>
                </>}

                {ele && ele.isRiskSurveyType && ele.isRiskSurveyType === "DEFAULTASSESSMENT" && (ele && ele.responses && ele.responses["Rank1"]) && <>
                  <div className="bg-white border rounded-lg p-6 flex flex-col justify-between shadow-[0_4px_25px_rgba(0,0,0,0.02)] hover:shadow-md transition duration-200 text-left">
                    <div className="mb-5">
                      <Heading className="text-xl mb-2 cursor-none" title="Top 5 Strengths" />
                      <p className="text-sm textlight leading-relaxed">Discover your 28 unique talent themes and understand your natural wiring.</p>
                    </div>

                    <div className="space-y-2 mb-4">
                      {getAssessmentTop5List(ele).map((ele) => (
                        <>
                          <div className="pl-6 pb-1">
                            <div class="relative flex items-center py-3 text-black  text-lg pl-10 pr-12 w-full" style={{
                              background: getLightColor(ele.bucket), color: "#3D405B"
                            }}>
                              <div class="absolute left-0 top-1/2 -translate-y-1/2 -ml-6">
                                <div class="w-14 h-14 rounded-full flex items-center justify-center text-black font-bold text-base border-4 border-white" style={{
                                  background: hexToRgbA(ele.color, "1.0"), color: "#3D405B"
                                }}>{ele.id}</div>
                              </div>
                              <span className="w-32 text-left font-semibold">{ele.dimension}</span>
                              <span className="text-sm">{ele.desc}</span>
                            </div>
                          </div>
                        </>
                      ))}
                    </div>

                    <button className="w-full border border-[#09529b] textcolor px-4 py-3 rounded-md flex items-center justify-center space-x-2 transition duration-150 group">
                      <span>View Full Report</span>
                      <svg className="w-4 h-4 transform group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </button>
                  </div>
                </>}
              </>
            ))}
          </div>
        </div>

      </DashboardUser>
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment
  };
}

export default connect(mapStateToProps)(Overview);